import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/loader';
import Modal from '../../components/modal';
import AssetConfig from '../../components/assetconfig';
import ToastHandler from '../../components/toasthandler';

import {
  fetchAddresses,
  addNewAddress,
  updateAddress,
  deleteAddress,
} from '../../actions';

const dateFormat = 'L LT';

class NewAddressModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      referenceId: '',
      asset: 'BTC',
      nickname: '',
      address: '',
      tag: '',
      otp: '',
      pristine: true,
      step: '',
      manualYubiKey: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.showCrypto = this.showCrypto.bind(this);
    this.startEdit = this.startEdit.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.submitEdit = this.submitEdit.bind(this);
    this.startDelete = this.startDelete.bind(this);
    this.toggleYubikeyListener = this.toggleYubikeyListener.bind(this);
    this.captureYubiKey = this.captureYubiKey.bind(this);
    this.toggleYubiKeyManual = this.toggleYubiKeyManual.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
  }

  componentWillUnmount() {
    this.toggleYubikeyListener('DISABLE');
  }

  toggleYubikeyListener(type) {
    if (type === 'ENABLE') {
      document.addEventListener('keypress', this.captureYubiKey, false);
    }
    if (type === 'DISABLE') {
      document.removeEventListener('keypress', this.captureYubiKey, false);
    }
  }

  toggleYubiKeyManual() {
    const { manualYubiKey } = this.state;
    if (!manualYubiKey) {
      this.toggleYubikeyListener('DISABLE');
    } else {
      this.toggleYubikeyListener('ENABLE');
    }
    this.setState({manualYubiKey: !manualYubiKey, otp: ''})
  }

  captureYubiKey(e) {
    const { user } = this.props;
    const { otp, step, editItem } = this.state;
    if (e.which === 13 || e.key === 'Enter') {
      if (step === 'DELETING') {
        this.deleteAddress(e);
      }
      if (step === 'EDITING') {
        this.submitEdit(e);
      }
      return;
    }
    let useYubikey = '' + e.key;
    if (otp) {
      useYubikey = otp + e.key;
    }
    this.setState({otp: useYubikey});
  }

  startDelete(item) {
    const { user } = this.props;
    let yubiEnabled;
    if (user.security) {
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }
    if (yubiEnabled) {
      this.toggleYubikeyListener('ENABLE');
    }
    this.setState({
      step: 'DELETING',
      referenceId: item.referenceId,
      asset: item.typeHandle,
      nickname: item.nickname,
      address: item.address,
      tag: item.tag,
      pristine: true,
    })
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value, pristine: false });
  }

  showCrypto(asset) {
    const { assets } = this.props;
    let assetData;
    if (assets && assets.length) {
      assetData = assets.find((item) => {
        return item.handle === asset;
      });
    }
    let send;
    let receive;
    if (assetData && assetData.defaults) {
      send = assetData.defaults.some((e) => Object.prototype.hasOwnProperty.call(e, 'SEND'));
      receive = assetData.defaults.some((e) => Object.prototype.hasOwnProperty.call(e, 'RECV'));
    }
    let assetConf;
    if (AssetConfig && AssetConfig.length) {
      assetConf = AssetConfig.find((item) => item.handle === asset.toUpperCase());
    }
    let assetEnabled;
    if (assetConf && assetConf.enabled) {
      assetEnabled = assetConf.enabled;
    }
    if (assetEnabled && (send || receive)) {
      return true;
    } else {
      return false;
    }
  }

  startEdit(address) {
    this.setState({
      step: 'EDITING',
      referenceId: address.referenceId,
      asset: address.typeHandle,
      nickname: address.nickname,
      address: address.address,
      tag: address.tag,
      pristine: true,
    })
  }

  cancelEdit() {
    this.setState({
      step: '',
      referenceId: '',
      asset: 'BTC',
      nickname: '',
      address: '',
      tag: '',
      pristine: true,
    })
  }

  submitEdit() {
    const { referenceId, asset, nickname, address, tag } = this.state;
    const { dispatch } = this.props;
    const data = {
      referenceId,
      nickname,
      tag
    }
    this.setState({pristine: true})
    dispatch(updateAddress(data))
      .then((res) => {
        if (res.type === 'UPDATE_ADDRESSBOOK_ADDRESS_SUCCESS') {
          this.toggleYubikeyListener('DISABLE');
          this.setState({step: 'UPDATED'})
          dispatch(fetchAddresses());
        }
      });
  }

  deleteAddress() {
    const { referenceId, otp } = this.state;
    const { dispatch } = this.props;
    const data = {
      referenceId,
    }
    const params = {
      otp,
    }
    this.setState({pristine: true})
    dispatch(deleteAddress(data, params))
      .then((res) => {
        if (res.type === 'DELETE_ADDRESSBOOK_ADDRESS_SUCCESS') {
          this.toggleYubikeyListener('DISABLE');
          this.setState({step: 'DELETED'})
          dispatch(fetchAddresses());
        }
      });
  }

  render() {
    const { asset, nickname, address, tag, pristine, step, manualYubiKey, otp, referenceId } = this.state;
    const { addressbook, errors, success, assets, user } = this.props;
    let tableLoop = <tr><td colSpan="4" className="no-data text-center">No Data</td></tr>;
    let tableData;
    if (addressbook && addressbook.data && addressbook.data.length) {
      tableData = addressbook.data;
    }

    const assetLoop = assets && assets.length && assets.map((value, index) => {
      let handle;
      let humHandle;
      let urlAsset;
      if (value.handle) {
        handle = value.handle;
      }
      if (value.name) {
        humHandle = value.name;
      }
      if (humHandle) {
        urlAsset = humHandle.replace(/\s+/g, '-').toLowerCase();
      }

      if (this.showCrypto(handle)) {
        return (
          <option key={`asset-${index}`} value={handle}>{handle} | {humHandle}</option>
        );
      }
      return (null);
    });

    if (tableData) {
      tableLoop = tableData.map((item, index) => {
        return (
          <tr key={index} className="text-transform-none">
            <td>{item.typeHandle || ''}</td>
            <td>{item.nickname || ''}</td>
            <td>{item.address || ''}</td>
            <td className="hide-mob">{item.tag || ''}</td>
            <td style={{textAlign: 'center'}}>
              <span
                style={{cursor: 'pointer'}}
                onClick={() => this.startEdit(item)}
              >
                <FontAwesomeIcon
                  icon={faPencilAlt}
                  style={{
                    color: 'rgb(0, 145, 255)',
                  }}
                />
              </span>
            </td>
            <td style={{textAlign: 'center'}}>
              <span
                style={{cursor: 'pointer'}}
                onClick={() => this.startDelete(item)}
              >
                <FontAwesomeIcon
                  icon={faTrashAlt}
                  style={{
                    color: 'rgb(255, 82, 117)',
                  }}
                />
              </span>
            </td>
          </tr>
        );
      });
    }

    let otpEnabled;
    let yubiEnabled;

    if (user.security) {
      const otpHandle = user.security.find(e => e.typeHandle === 'OTP');
      if (otpHandle && otpHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    const editComplete = !pristine;

    const deleteComplete = !pristine && referenceId && otp;

    if (step === 'DELETED') {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Address Deleted Successfully</div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <p>The following address was successfully deleted:</p>
              <p style={{maxWidth: '420px', textAlign: 'left', margin: 'auto'}}>
                <b>Address: </b>{address}
                <br/>
                <b>Asset: </b>{asset}
                <br/>
                <b>Nickname: </b>{nickname}
                <br/>
                <b>Tag: </b>{tag}
              </p>
            </div>
            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
                <span>
                  Close
                </span>
              </button>
              <button className="vlt-button" type="button" onClick={() => this.cancelEdit()}>
                <span>
                  Edit another address
                </span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (step === 'UPDATED') {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Address Updated Successfully</div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <p>The following address was successfully updated:</p>
              <p style={{maxWidth: '420px', textAlign: 'left', margin: 'auto'}}>
                <b>Address: </b>{address}
                <br/>
                <b>Asset: </b>{asset}
                <br/>
                <b>Nickname: </b>{nickname}
                <br/>
                <b>Tag: </b>{tag}
              </p>
            </div>
            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
                <span>
                  Close
                </span>
              </button>
              <button className="vlt-button" type="button" onClick={() => this.cancelEdit()}>
                <span>
                  Edit another address
                </span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (step === 'DELETING') {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Confirm Deleting Address</div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <p>The following address will be deleted:</p>
              <p style={{maxWidth: '420px', textAlign: 'left', margin: 'auto'}}>
                <b>Asset: </b>{asset}
                <br/>
                <b>Nickname: </b>{nickname}
                <br/>
                <b>Address: </b>{address}
                <br/>
                <b>Tag: </b>{tag}
              </p>
            </div>
            {otpEnabled ? (
              <>
                <div className="cell small-12 medium-12 large-12">
                  <div className="text-center">
                    <p>
                      <b>
                        Two-Factor Auth Code
                      </b>
                    </p>
                    <input className="modal-input" type="text" name="otp" placeholder="Two-Factor Auth"  autoComplete="off" id="otp" value={otp} onChange={this.handleChange} />
                  </div>
                </div>
                <div className="cell small-12 medium-12 large-12 modal-actions">
                  <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
                    <span>
                      Cancel
                    </span>
                  </button>
                  <button className="vlt-button" type="button" disabled={!deleteComplete} onClick={(e) => this.deleteAddress(e)}>
                    <span>
                      Confirm
                    </span>
                  </button>
                </div>
              </>
            ) : null }
            {yubiEnabled ? (
              <>
                <div className="cell small-12 medium-12 large-12">
                  <div className="text-center">
                    <div>
                      <h2>
                        YubiKey Auth
                      </h2>
                      <p>
                        1. Insert your YubiKey into a USB port
                        <br />
                        {manualYubiKey ? (
                          '2. Enter your YubiKey code in the field below'
                        ) : (
                          '2. Touch the YubiKey button'
                        )}
                      </p>
                    </div>
                    <div>
                      <div>
                        <img alt="YubiKeys" src={ process.env.REACT_APP_CDN + '/assets/images/yubikeys.png'} style={{maxWidth: '80%', marginBottom: '20px'}}/>
                      </div>
                      {manualYubiKey ? (
                        <div>
                          <input id="otp" className="modal-input" type="password" name="otp" placeholder="Enter YubiKey" value={otp} autoComplete="off" onChange={this.handleChange} autoFocus />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="cell small-12 medium-12 large-12 modal-actions">
                  <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
                    <span>
                      Cancel
                    </span>
                  </button>
                  {manualYubiKey ? (
                    <button className="vlt-button" type="button" disabled={!deleteComplete} onClick={(e) => this.deleteAddress(e)}>
                      <span>
                        Confirm
                      </span>
                    </button>
                  ) : (
                    <button className="button" type="submit" onClick={this.toggleYubiKeyManual}>
                      <span>
                        Manual YubiKey Confirmation
                      </span>
                    </button>
                  )}
                </div>
              </>
            ) : null }
          </div>
        </div>
      );
    }


    if (step === 'EDITING') {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Edit Address</div>
              <div className="modal-subheading">
                Edit the form below to add a new crypto address.
              </div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <div className="input-wrapper">
                <p className="iw-l">Address:</p>
                <p className="text-left"><b>{address}</b></p>
              </div>
              <div className="input-wrapper">
                <p className="iw-l">Asset:</p>
                <p className="text-left"><b>{asset}</b></p>
              </div>
              <div className="input-wrapper">
                <p className="iw-l">Nickname:</p>
                <input id="nickname" className="modal-input" type="text" name="nickname" placeholder="Nickname" value={nickname} onChange={this.handleChange} />
              </div>
              <div className="input-wrapper">
                <p className="iw-l">Tag:</p>
                <input id="tag" className="modal-input" type="text" name="tag" placeholder="Tag" value={tag} onChange={this.handleChange} />
              </div>
            </div>
            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="button" type="button" onClick={() => this.cancelEdit(null)}>
                <span>
                  Cancel
                </span>
              </button>
              <button className="vlt-button" type="button" disabled={!editComplete} onClick={() => this.submitEdit()}>
                <span>
                  Submit
                </span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="cell small-12 medium-12 large-12">
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="modal-heading">Edit Addresses</div>
            <div className="modal-subheading">
              Click the pencil icon to edit, or the trash icon to delete an address from your addressbook.
            </div>
          </div>
          <div className="cell small-12 medium-12 large-12">
            <table className="addressbook-table">
              <colgroup>
                <col style={{width: '10%'}}></col>
                <col style={{width: '20%'}}></col>
                <col style={{width: '30%'}}></col>
                <col style={{width: '20%'}}></col>
                <col className="hide-mob" style={{width: '10%'}}></col>
                <col style={{width: '10%'}}></col>
              </colgroup>
              <thead>
                <tr>
                  <th>Asset</th>
                  <th>Nickname</th>
                  <th>Address</th>
                  <th className="hide-mob">Tag</th>
                  <th style={{textAlign: 'center'}}>Edit</th>
                  <th style={{textAlign: 'center'}}>Delete</th>
                </tr>
              </thead>
              <tbody>
                {tableLoop}
              </tbody>
            </table>
          </div>
          <div className="cell small-12 medium-12 large-12 modal-actions">
            <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
              <span>
                Close
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.addressbook.errors,
  success: state.addressbook.success,
  addressbook: state.addressbook.addressbook,
  assets: state.assets.assets,
});

export default connect(mapStateToProps)(NewAddressModal);
